/* NUX Support Center: search, table of contents, table wrapping. No dependencies. */
(function () {
  'use strict';

  function slug(text) {
    return text.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* ---------- Article pages ---------- */
  function initArticle(root) {
    var body = root.querySelector('[data-nxs-body]');
    if (!body) return;

    // Wrap tables so wide ones scroll instead of breaking the layout on phones.
    body.querySelectorAll('table').forEach(function (t) {
      t.removeAttribute('border'); t.removeAttribute('cellpadding'); t.removeAttribute('style');
      if (t.parentElement && t.parentElement.classList.contains('nxs-table')) return;
      var wrap = document.createElement('div');
      wrap.className = 'nxs-table';
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', 'Table');
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
    });

    // Give every h2 a stable id so product pages can deep-link (#downloads, #common-fixes).
    var used = {};
    var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
    heads.forEach(function (h) {
      var id = h.id || slug(h.textContent);
      while (used[id]) id += '-2';
      used[id] = true;
      h.id = id;
    });

    // Download lists in product hubs get spec-sheet styling.
    var dl = body.querySelector('h2#downloads');
    if (dl) {
      for (var el = dl.nextElementSibling; el && el.tagName !== 'H2'; el = el.nextElementSibling) {
        if (el.tagName === 'UL') el.classList.add('nxs-dl');
      }
    }

    // Table of contents for longer articles.
    var toc = root.querySelector('[data-nxs-toc]');
    if (toc && heads.length >= 3) {
      var list = toc.querySelector('ol');
      heads.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;

      if ('IntersectionObserver' in window) {
        var links = list.querySelectorAll('a');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (l) { l.removeAttribute('aria-current'); });
            var cur = list.querySelector('a[href="#' + e.target.id + '"]');
            if (cur) cur.setAttribute('aria-current', 'true');
          });
        }, { rootMargin: '0px 0px -70% 0px' });
        heads.forEach(function (h) { io.observe(h); });
      }
    }

    // Ids are created after load, so honour a deep link now.
    if (location.hash) {
      var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target) target.scrollIntoView();
    }
  }

  /* ---------- Support Center search ----------
     Uses event delegation: the theme can re-render section markup after load,
     which would drop listeners bound directly to the input. */
  function getItems(root) {
    if (root._nxsItems) return root._nxsItems;
    var data = root.querySelector('[data-nxs-index]');
    var items = [];
    try { items = JSON.parse(data.textContent); } catch (e) { items = []; }
    items.forEach(function (it) {
      it.hay = (it.t + ' ' + it.s + ' ' + it.g).toLowerCase().replace(/[-_]/g, ' ');
      it.title = it.t.toLowerCase().replace(/[-_]/g, ' ');
    });
    root._nxsItems = items;
    return items;
  }

  function norm(q) { return q.toLowerCase().replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim(); }

  function runSearch(input) {
    var root = input.closest('[data-nxs-center]');
    if (!root) return;
    var out = root.querySelector('[data-nxs-results]');
    var status = root.querySelector('[data-nxs-status]');
    var items = getItems(root);
    var q = norm(input.value);
    out.innerHTML = '';
    if (q.length < 2) { out.hidden = true; status.textContent = ''; return; }
    var terms = q.split(' ');
    // Also match model numbers typed without a dash: "b8" finds "B-8".
    var squash = q.replace(/\s/g, '');
    var hits = items.filter(function (it) {
      var all = terms.every(function (t) { return it.hay.indexOf(t) !== -1; });
      return all || it.hay.replace(/\s/g, '').indexOf(squash) !== -1;
    }).map(function (it) {
      var score = 0;
      terms.forEach(function (t) { if (it.title.indexOf(t) !== -1) score += 2; });
      if (it.title.indexOf(q) === 0) score += 3;
      return { it: it, score: score };
    }).sort(function (a, b) { return b.score - a.score; }).slice(0, 12);

    hits.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = h.it.u;
      var s = document.createElement('strong'); s.textContent = h.it.t;
      a.appendChild(s);
      if (h.it.s) { var sp = document.createElement('span'); sp.textContent = h.it.s; a.appendChild(sp); }
      li.appendChild(a);
      out.appendChild(li);
    });
    out.hidden = hits.length === 0;
    status.textContent = hits.length
      ? hits.length + (hits.length === 1 ? ' article matches' : ' articles match') + ' "' + input.value.trim() + '"'
      : 'No articles match "' + input.value.trim() + '". Try a model name such as B-8, or a word like pairing or firmware.';
  }

  if (!window.__nxsBound) {
    window.__nxsBound = true;
    var timer;
    document.addEventListener('input', function (e) {
      var input = e.target.closest && e.target.closest('[data-nxs-q]');
      if (!input) return;
      clearTimeout(timer);
      timer = setTimeout(function () { runSearch(input); }, 120);
    });
    document.addEventListener('keydown', function (e) {
      var input = e.target.closest && e.target.closest('[data-nxs-q]');
      if (!input) return;
      if (e.key === 'Enter') {
        var root = input.closest('[data-nxs-center]');
        var first = root && root.querySelector('[data-nxs-results] a');
        if (first) { e.preventDefault(); first.click(); }
      }
      if (e.key === 'Escape') { input.value = ''; runSearch(input); }
    });
  }

  function init() {
    document.querySelectorAll('[data-nxs-article]').forEach(function (root) {
      if (root.dataset.nxsReady) return;
      root.dataset.nxsReady = '1';
      initArticle(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Re-run after the theme finishes its own rendering and in the theme editor.
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
